<template>
  <div class="card-item">
    <!-- Drag handle -->
    <v-tooltip left color="surface_neutral_selected">
      <template v-slot:activator="{ on, attrs }">
        <div class="card-item__drag" role="button" tabindex="0" aria-label="Arraste para mover este item" v-bind="attrs" v-on="on">
          <v-icon size="18" color="text_secondary">mdi-drag</v-icon>
        </div>
      </template>
      <span>Segure e arraste para a coluna de exibição</span>
    </v-tooltip>

    <!-- Body -->
    <div class="card-item__body">
      <span class="card-item__title" style="font-weight: 600">
        {{ item.dsc_titulo_enquete }}
      </span>

      <span v-if="item.dsc_descricao_enquete" class="card-item__info">
        {{ item.dsc_descricao_enquete }}
      </span>

      <!-- Status + alternativas -->
      <div class="d-flex align-center flex-wrap" style="gap: 8px">
        <span v-if="item.flg_encerrado" class="card-item__status card-item__status--closed">
          Encerrada em {{ formatDate(item.updated_at) }} · {{ formatHour(item.updated_at) }}
        </span>
        <span class="card-item__info">{{ item.enquete_opcoes.length }} alternativas</span>
      </div>

      <!-- Meta row -->
      <div class="card-item__meta">
        <span class="meta-source">{{ portalDisplayName(item.tenant_id_backstage) }}</span>
        <span class="meta-separator">·</span>
        <span>{{ formatDate(item.created_at) }}</span>
        <span class="meta-separator">·</span>
        <span>{{ formatHour(item.created_at) }}</span>
      </div>
    </div>

    <!-- Actions -->
    <div class="card-item__actions">
      <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on, attrs }">
          <div
            class="card-action-box card-action-box--move"
            v-bind="attrs"
            v-on="on"
            @click="setEnqueteExibir"
           role="button" aria-label="Enviar para exibição">
            <v-icon>mdi-arrow-right</v-icon>
          </div>
        </template>
        <span>Enviar para exibição</span>
      </v-tooltip>

      <DownloadEnqueteQRCODE :item="item" />
      <ModalEditarOpcoesEnquete :item="item" :page-recebidas="currentPage" @option-updated="onOptionUpdated" />
    </div>
  </div>
</template>

<script>
import ModalEditarOpcoesEnquete from "@/components/Modal/Enquetes/ModalEditarOpcoesEnquete.vue";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import { formatDate, formatHour } from "@/utils/dateUtils";
import DownloadEnqueteQRCODE from "@/components/Modal/Enquetes/DownloadEnqueteQRCODE.vue";
import { mapGetters } from "vuex";
export default {
  props: {
    item: Object,
    getEnquetesProducao: Function,
    getEnqueteEmExibicao: Function,
    currentPage: Number,
    isFavoritaTab: Boolean,
  },
  components: {
    ModalEditarOpcoesEnquete,
    DownloadEnqueteQRCODE,
  },
  data() {
    return {
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      isSettingExibir: false,
    };
  },
  computed: {
    ...mapGetters({
      portalDisplayName: "portais/getPortalDisplayName",
    }),
    cod_producao() {
      return this.$store.state.producoes.selectedProducao.cod_producao;
    },
  },
  methods: {
    formatDate,
    formatHour,
    capitalize(string) {
      return capitalizeString(string);
    },
    async setEnqueteExibir() {
      if (this.isSettingExibir) return;
      this.isSettingExibir = true;

      const { id } = this.item;
      const cod_producao = this.cod_producao;
      try {
        await apiClient.put(`/enquetes/exibicao`, {
          cod_producao: cod_producao,
          id_enquete: id,
        });
        await this.getEnqueteEmExibicao({ cod_producao });
        this.$emit("reload-enquetes");
      } catch (error) {
        console.error(error);
        this.$toast.error("Erro ao enviar enquete para exibição");
      } finally {
        this.isSettingExibir = false;
      }
    },
    onOptionUpdated() {
      this.$emit("reload-enquetes");
    },
  },
};
</script>
